<section class="logout-page">
    <p>Signing you out...</p>
</section>